import { gql } from "@apollo/client";
import { ButtonBase, Paper } from "@mui/material";
import Grid from "atoms/Grid";
import { SPACING_DENSE } from "helpers/spacings";
import useData from "helpers/useData";
import { Plus } from "mdi-material-ui";
import Message from "molecules/Message";
import Section from "molecules/Section";
import React from "react";

import EventCard, { EventCardFragment } from "./EventCard";

export const GameOverviewHighlightsFragment = gql`
  fragment GameOverviewHighlightsFragment on Game {
    id
  }
`;

export const GameOverviewHighlightsGamePlayerFragment = gql`
  fragment GameOverviewHighlightsGamePlayerFragment on GamePlayer {
    id
    person {
      id
      fullNameWithAnonymisation
    }
  }
`;

export default function GameOverviewHighlights({ game, gamePlayer }) {
  const [data] = useData(
    gql`
      query GameOverviewHighlights($gamePlayerId: ID!) {
        gamePlayer(id: $gamePlayerId) {
          id
          events {
            id
            ...EventCardFragment
          }
        }
      }
      ${EventCardFragment}
    `,
    {
      gamePlayerId: gamePlayer?.id,
    },
    {
      skip: !gamePlayer,
    },
  );

  return (
    <Section title={`${gamePlayer?.person.fullNameWithAnonymisation}'s Highlights`}>
      {data?.gamePlayer.events.length <= 5 && (
        <>
          <Message>Let’s get tagging! The more events you tag, the faster you climb up the leaderboard!</Message>
        </>
      )}
      <Grid gridItemWidth="150px">
        {data?.gamePlayer.events.map((event) => (
          <EventCard key={event.id} event={event} />
        ))}
        <Paper
          component={ButtonBase}
          disabled={!game}
          href={`/game/${game?.id}/video`}
          variant="outlined"
          style={{
            display: "flex",
            flexFlow: "column nowrap",
            justifyContent: "center",
            alignItems: "center",
            padding: SPACING_DENSE,
            gap: SPACING_DENSE,
          }}
        >
          <Plus />
          <div style={{ fontSize: 12, opacity: 0.8 }}>Get Tagging!</div>
        </Paper>
      </Grid>
    </Section>
  );
}
